import React from 'react'
import { Text } from '@theme-ui/components'
export default function Copyright({ name }) {
  return (
    <Text variant='copyright.container' className='copyright'>
      ©{new Date().getFullYear()} Greenwich Dark House LLC
    </Text>
  )
}
